module.exports = __webpack_public_path__ + "img/feefo.0b06c06.png";